export default __webpack_public_path__ + "static/media/score.8d41a333.png";